type DistinguishedUser = {
  commonName: string;
  organizationalUnits: string[];
  domainComponents: string[];
};

const CN_MATCH = /(?<=CN=)(?:\\.|[^,])+/g;
const OU_MATCH = /(?<=OU=)[^,]+/g;
const DC_MATCH = /(?<=DC=)[^,]+/g;
export default function parseDistinguishedName(distinguishedName: string): DistinguishedUser | null {
  if (!canParseDistinguishedName(distinguishedName)) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const commonName = distinguishedName
    .match(CN_MATCH)!
    .map((cn) => cn.replace(/\\,/g, ','))
    .at(0)!;
  const organizationalUnits = distinguishedName.match(OU_MATCH) ?? [];
  const domainComponents = distinguishedName.match(DC_MATCH) ?? [];

  return {
    commonName,
    organizationalUnits,
    domainComponents,
  };
}

function canParseDistinguishedName(distinguishedName: string): boolean {
  return (
    hasValidCommonName(distinguishedName) &&
    hasValidOrganizationalUnit(distinguishedName) &&
    hasValidDomainComponent(distinguishedName)
  );
}

function hasValidCommonName(distinguishedName: string): boolean {
  return CN_MATCH.test(distinguishedName);
}

function hasValidOrganizationalUnit(distinguishedName: string): boolean {
  return OU_MATCH.test(distinguishedName);
}

function hasValidDomainComponent(distinguishedName: string): boolean {
  return DC_MATCH.test(distinguishedName);
}
